import React, { useEffect, useState, useRef } from "react";
import { X, Upload, FileText, Check } from "lucide-react";
import { Form } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import ReactDatePicker from "react-datepicker";
import Tooltip from "react-bootstrap/Tooltip";
import RatingComponent from "../../../../components/RatingComponent";
import RatingComponentWithoutNA from "../../../../components/RatingComponentWithoutNA";
import Editor from "../../../../components/editor";
import HrDropdown from "../../RecrtProcess/candidate/component/hrdropdown";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import validate from "./validate";
import { isCtcInputAllowed, validateCtc } from "../../../../utils/ctc";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploader } from "../../../../components/FileUploader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
const NewApplication = () => {
  const navigate = useNavigate();
  const { id, job_master_id } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});
  console.log("errors",errors);
  
  const [FileName, setFileName] = useState([]);
  const [NoOfProjectContent, setNoOfProjectContent] = useState("");
  const [roleOfProjectContent, setRoleOfProjectContent] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [jsonData, setJsonData] = useState(null);
  const [resumeFile, setResumeFile] = useState([]);
  const [refferralDetails, setReferralInput] = useState({
    show: false,
    label: "",
    placeholder: "",
  });
  const [referrals, setReferrals] = useState([]);

  // Resume Upload State
  const [showModal, setShowModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  // source section
  const [showOthersInput, setShowOthersInput] = useState(false);
  const [showCampusInput, setShowCampusInput] = useState(false);
  const [showJobPortalInput, setShowJobPortalInput] = useState(false);
  const handleAdditionalInputChange = (show) => {
    setShowOthersInput(show);
    setShowCampusInput(show);
    setShowJobPortalInput(show);
  };
  const notice_period = [
    { value: "", label: "Select..." },
    { value: "0", label: "0" },
    { value: "15", label: "15" },
    { value: "30", label: "30" },
    { value: "45", label: "45" },
    { value: "60", label: "60" },
    { value: "75", label: "75" },
    { value: "90", label: "90" },
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add New Applicant"));
  }, []);

  const handleCheckboxChange = (value) => {
    let updatedOptions;
    if (selectedOptions?.includes(value)) {
      updatedOptions = selectedOptions?.filter((option) => option !== value);
    } else {
      updatedOptions = [...selectedOptions, value];
    }

    setSelectedOptions(updatedOptions);

    // Update WorkDomainIDs in formData as a comma-separated string
    const updatedFormData = { ...formData };
    updatedFormData.WorkDomainIDs = updatedOptions.join(",");
    setFormData(updatedFormData);
  };
  let today = moment().format("DD-MMM-YYYY");
  let minDob = moment().subtract(18, "years").format("DD-MMM-YYYY");

  const initialFormData = {
    job_description_id: id,
    job_title: { label: "", value: job_master_id },
    AppliedDate: today,
    hr: "",
    RecruiterID: "",
    FirstName: "",
    LastName: "",
    Gender: "",
    EmailID: "",
    DateOfBirth: minDob,
    MobileNo: "",
    MobileNo1: "",
    SkillSet: [],
    SubSkillSet: [],
    IntroduceYourself: null,
    OralSkills: null,
    Accent: null,
    CurrentCompanyName: "",
    CurrentPosition: "",
    CurrentExperienceInYears: "",
    CurrentRelevantExperienceInYears: "",
    Qualifications: "",
    NoticePeriod: "",
    NoticePeriodRemarks: "",
    CurrentCTC: "",
    ExpectedCTC: "",
    ProjectOtherDesc: "",
    ProjectDetails: "",
    ProjectExamples: "",
    OtherChallenges: "",
    AreaDashboard: null,
    AreaArchitecture: null,
    AreaSDK: null,
    AreaReport: null,
    AreaAdministration: null,
    AreaOtherSkill: null,
    CurrentLocation: "",
    hr: "",
    OtherOptionValue: "", //demo other option
    PreferredLocation: "",
    ReasonForChange: "",
    ReferralNote: "",
    WillingToTravel: "",
    LeadCandidateStatus_189: 47,
    referralType: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [skillsetOptions, setskillsetOptions] = useState([]);
  const [subSkillOptions, setsubSkillOptions] = useState([]);
  const [jobTitleOption, setJobTitleOption] = useState([]);
  const [hrOption, setHrOption] = useState([]);
  const [genderOption, setGenderOption] = useState([]);
  const [sourceoption, setSourceOption] = useState([]);
  const [activeKey, setActiveKey] = useState("0");

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      const validTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (validTypes.includes(file.type)) {
        if (file.size <= 5 * 1024 * 1024) {
          setUploadedFile(file);
        } else {
          toast.error("File size must be less than 5 MB", { position: "top-right" });
        }
      } else {
        toast.error("Please upload a PDF, DOCX, or DOC file.", { position: "top-right" });
      }
    }
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.size <= 5 * 1024 * 1024) {
        setUploadedFile(file);
      } else {
        toast.error("File size must be less than 5 MB", { position: "top-right" });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    }
  };

  const removeFile = (e) => {
    e.stopPropagation();
    setUploadedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setUploadedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleResumeSubmit = async () => {
    if (!uploadedFile) {
      toast.error("Please select a file first");
      return;
    }

    setIsUploading(true);

    try {
      const formUploadData = new FormData();
      formUploadData.append("file", uploadedFile);

      const response = await PostFormServiceCaller(
        "https://api.nicesoftwaresolutions.com/parse-resume",
        formUploadData,
        "post",
        7000
      );

      if (response.status !== 200) {
        throw new Error("Upload failed");
      }

      const result = response?.data;
      if (result) {
        try {
          let genderValue = "";
          if (result.Gender) {
            const gender = result.Gender.toLowerCase().trim();
            if (gender === "male" || gender === "m") {
              genderValue = 148;
            } else if (gender === "female" || gender === "f") {
              genderValue = 149;
            }
          }
          const secondFormData = new FormData();

          secondFormData.append("FirstName", result.FirstName || "");
          secondFormData.append("LastName", result.LastName || "");
          secondFormData.append("FullName", result.FullName || "");
          secondFormData.append("EmailID", result.EmailID || "");
          secondFormData.append("MobileNo", result.MobileNo || "");
          secondFormData.append("MobileNo1", result.MobileNo1 || "");
          secondFormData.append(
            "DateOfBirth",
            result.DateOfBirth
              ? moment(result.DateOfBirth, [
                  "Do MMM YYYY",
                  "DD-MM-YYYY",
                  "YYYY-MM-DD",
                ]).format("YYYY/MM/DD")
              : ""
          );
          secondFormData.append("Gender", genderValue);
          secondFormData.append("CurrentLocation", result.CurrentLocation || "");
          secondFormData.append("CorrespondenceAddress", result.CorrespondenceAddress || "");
          secondFormData.append("PermanentAddress", result.PermanentAddress || "");
          secondFormData.append("PreferredLocation", result.PreferredLocation || "");
          secondFormData.append("CurrentCompanyName", result.CurrentCompanyName || "");
          secondFormData.append("CurrentPosition", result.CurrentPosition || "");
          secondFormData.append("CurrentExperienceInYears", result.CurrentExperienceInYears || "");
          secondFormData.append("CurrentRelevantExperienceInYears", result.CurrentRelevantExperienceInYears || "");
          secondFormData.append("CurrentCTC", result.CurrentCTC || "");
          secondFormData.append("ExpectedCTC", result.ExpectedCTC || "");
          secondFormData.append("NoticePeriod", result.NoticePeriod || "");
          secondFormData.append("NoticePeriodRemarks", result.NoticePeriodRemarks || "");
          secondFormData.append("SkillSet", result.SkillSet || "");
          secondFormData.append("SubSkillSet", result.SubSkillSet || "");
          secondFormData.append("ProjectKnows", result.ProjectKnows || "");
          secondFormData.append("ProjectTechnology", result.ProjectTechnology || "");
          secondFormData.append("TechnologyRemark", result.TechnologyRemark || "");
          secondFormData.append("Qualifications", result.Qualifications || "");
          secondFormData.append("NoticePeriodExtractedText", result.NoticePeriodExtractedText || "");
          secondFormData.append("ProjectWork", result.ProjectWork || "");
          secondFormData.append("IntroduceYourself", result.IntroduceYourself || "");
          secondFormData.append("createddate", new Date().toISOString());
          secondFormData.append("CurrentJobDescription", result.CurrentJobDescription || "");

          secondFormData.append("ResumePath", uploadedFile);
          
          const aiResponse = await PostFormServiceCaller(
            `${API_URL}ai-parsed-candidate-details`,
            secondFormData,
            "post",
            7000
          );

          if (aiResponse?.data?.status) {
            toast.success(aiResponse.data.message || "Resume Uploaded successfully!");
            
            // Auto-fill formData
            let mappedSkills = formData.SkillSet || [];
            let mappedSubSkills = formData.SubSkillSet || [];
            
            if (result.SkillSet) {
              const skillArray = Array.isArray(result.SkillSet) ? result.SkillSet : (typeof result.SkillSet === 'string' ? result.SkillSet.split(',') : []);
              const parsedSkills = skillArray.map(s => String(s).trim().toLowerCase());
              mappedSkills = skillsetOptions.filter(opt => parsedSkills.some(ps => ps === opt.label.toLowerCase() || ps.includes(opt.label.toLowerCase()) || opt.label.toLowerCase().includes(ps)));
              
              if (mappedSkills.length > 0) {
                const skillValues = mappedSkills.map(opt => opt.value).join(",");
                try {
                  const subResponse = await PostServiceCaller(
                    API_URL + "fetch-subskils",
                    { skillId: skillValues },
                    "post"
                  );
                  const subSkillData = subResponse?.data;
                  const newSubSkillOptions = subSkillData?.map((subSkill) => ({
                    value: subSkill.ID,
                    label: subSkill.SubSkill,
                  })) || [];
                  setsubSkillOptions(newSubSkillOptions);

                  if (result.SubSkillSet) {
                    const subSkillArray = Array.isArray(result.SubSkillSet) ? result.SubSkillSet : (typeof result.SubSkillSet === 'string' ? result.SubSkillSet.split(',') : []);
                    const parsedSubSkills = subSkillArray.map(s => String(s).trim().toLowerCase());
                    mappedSubSkills = newSubSkillOptions.filter(opt => parsedSubSkills.some(ps => ps === opt.label.toLowerCase() || ps.includes(opt.label.toLowerCase()) || opt.label.toLowerCase().includes(ps)));
                  }
                } catch (error) {
                  console.error("Error fetching subSkill options:", error);
                }
              }
            } else if (result.SubSkillSet) {
              const subSkillArray = Array.isArray(result.SubSkillSet) ? result.SubSkillSet : (typeof result.SubSkillSet === 'string' ? result.SubSkillSet.split(',') : []);
              const parsedSubSkills = subSkillArray.map(s => String(s).trim().toLowerCase());
              mappedSubSkills = subSkillOptions.filter(opt => parsedSubSkills.some(ps => ps === opt.label.toLowerCase() || ps.includes(opt.label.toLowerCase()) || opt.label.toLowerCase().includes(ps)));
            }

            setFormData(prev => ({
              ...prev,
              SkillSet: mappedSkills.length > 0 ? mappedSkills : prev.SkillSet,
              SubSkillSet: mappedSubSkills.length > 0 ? mappedSubSkills : prev.SubSkillSet,
              FirstName: result.FirstName || prev.FirstName,
              LastName: result.LastName || prev.LastName,
              EmailID: result.EmailID || prev.EmailID,
              MobileNo: result.MobileNo || prev.MobileNo,
              MobileNo1: result.MobileNo1 || prev.MobileNo1,
              Gender: genderValue || prev.Gender,
              CurrentLocation: result.CurrentLocation || prev.CurrentLocation,
              PreferredLocation: result.PreferredLocation || prev.PreferredLocation,
              CurrentCompanyName: result.CurrentCompanyName || prev.CurrentCompanyName,
              CurrentPosition: result.CurrentPosition || prev.CurrentPosition,
              CurrentExperienceInYears: result.CurrentExperienceInYears || prev.CurrentExperienceInYears,
              CurrentRelevantExperienceInYears: result.CurrentRelevantExperienceInYears || prev.CurrentRelevantExperienceInYears,
              CurrentCTC: result.CurrentCTC || prev.CurrentCTC,
              ExpectedCTC: result.ExpectedCTC || prev.ExpectedCTC,
              NoticePeriod: result.NoticePeriod || prev.NoticePeriod,
              DateOfBirth: result.DateOfBirth
                ? moment(result.DateOfBirth, [
                    "Do MMM YYYY",
                    "DD-MM-YYYY",
                    "YYYY-MM-DD",
                  ]).format("DD-MMM-YYYY")
                : prev.DateOfBirth,
            }));
            
            setFileName(uploadedFile.name);
            setResumeFile(uploadedFile);

          } else {
            console.error(aiResponse?.data?.message || "Something went wrong!");
            toast.error(aiResponse?.data?.message || "Failed to save AI Candidate details.");
          }
          setShowModal(false);
        } catch (aiError) {
          console.error("Error in second API call:", aiError);
          if (aiError.message?.toLowerCase().includes("network error")) {
            toast.error("Please Connect to VPN", { autoClose: 7000 });
          } else {
            console.error("Error in processing resume details.");
          }
        }
      }

      setUploadedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      if (error.message?.toLowerCase().includes("network error")) {
        toast.error("Please Connect to VPN");
      } else {
        toast.error("Error uploading file. Please try again.");
      }
    } finally {
      setIsUploading(false);
    }
  };

  const handleEditorChangeNoOfProject = (content) => {
    setNoOfProjectContent(content);
    const name = "NoOfProjectContent";

    // Check if there's an error for this field and clear it if necessary
    setErrors((prevErrors) => {
      if (prevErrors[name]) {
        return {
          ...prevErrors,
          [name]: null, // Clear the error for this field
        };
      }
      return prevErrors;
    });
  };

  const handleEditorChangeRoleOfProject = (content) => {
    setRoleOfProjectContent(content);
  };
  const handleRadioChange = (e) => {
    setFormData({
      ...formData,
      WillingToTravel: e.target.value,
    });
  };

  const handleRatingChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [mobileNoError, setMobileNoError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    let isValid = true;

    if (name === "CurrentCTC" || name === "ExpectedCTC") {
      // Only whole figures or decimals in rupees, so 820000 stays 820000
      if (!isCtcInputAllowed(value)) {
        setErrors((errors) => ({
          ...errors,
          [name]: {
            status: true,
            message:
              "Enter the amount in rupees, numbers only (e.g. 820000 or 820000.50).",
          },
        }));
        return;
      }
      setFormData({ ...formData, [name]: value });
      // The amount itself is checked on blur, so a half typed figure is not flagged
      setErrors((errors) => ({
        ...errors,
        [name]: { status: false, message: "" },
      }));
      return;
    }

    if (
      name === "CurrentExperienceInYears" ||
      name === "CurrentRelevantExperienceInYears"
    ) {
      isValid = /^\d{0,2}$/.test(value);
    } else if (name === "FirstName" || name === "LastName") {
      isValid = /^[a-zA-Z\s]*$/.test(value);
    } else if (name === "MobileNo") {
      isValid = /^\d*$/.test(value) && value.length <= 15; // Validate up to 10 digits for MobileNo
    }

    if (isValid) {
      setFormData({ ...formData, [name]: value });
      setErrors((errors) => ({
        ...errors,
        [name]: value,
      }));
    } else {
      setErrors((errors) => ({
        ...errors,
        [name]: {
          message:
            name === "FirstName" || name === "LastName"
              ? "Only alphabetic characters are allowed."
              : name === "MobileNo"
                ? "Mobile number must be in 10 digits and numeric."
                : "Only up to two digits are allowed.",
        },
      }));
    }

    // Additional check after updating the formData
    if (name === "MobileNo" && value.length > 0 && value.length < 10) {
      setErrors((errors) => ({
        ...errors,
        [name]: {
          message: "Mobile number must be in 10 digits.",
        },
      }));
    }
  };

  const handleCtcBlur = (event) => {
    const { name, value } = event.target;
    const label = name === "CurrentCTC" ? "Current CTC" : "Expected CTC";
    setErrors((errors) => ({
      ...errors,
      [name]: validateCtc(value, label),
    }));
  };


  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setFormData({ ...formData, [field]: formattedDate });
  };

  const fetchSkillOptions = async () => {
    try {
      const response = await GetServiceCaller(API_URL + "skills");
      const skillData = response?.data;
      const options = skillData?.map((skill) => ({
        value: skill.ID,
        label: skill.Name,
      }));
      setskillsetOptions(options);
    } catch (error) {
      console.error("Error fetching skill options:", error);
    }
  };
  const fetchSubSkillOptions = async (skill_id) => {

    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response?.data;
      const options = subSkillData?.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      // options.push(...subSkillOptions);
      setsubSkillOptions(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOption1, setSubSkillOptions1] = useState([]);
  const [skillValue, setSkillValue] = useState([]);

  const handleSkillChange = async (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option?.value);
    const skillValues = selectedValues.join(",");

    setFormData({ ...formData, SkillSet: selectedOptions });
    setSkillValue(selectedValues);

    setErrors((prevErrors) => ({
      ...prevErrors,
      SkillSet: { status: false, message: "" },
    }));

    if (skillValues != "") {
      fetchSubSkillOptions(skillValues);
    } else {
      setsubSkillOptions([]);
    }
  };

  const handleSubSkillChange = (selectedOptions) => {
    setFormData({ ...formData, SubSkillSet: selectedOptions });
  };
  // const handleFile = async (file) => {
  //   if (file) {
  //     setErrors((errors) => ({
  //       ...errors,
  //       resume: {
  //         message: "",
  //       },
  //     }));
  //     setFileName(file.name);
  //     setFormData((prevState) => ({
  //       ...prevState,
  //     }));
  //     setResumeFile(file);
  //   } else {
  //     setErrors((errors) => ({
  //       ...errors,
  //       resume: {
  //         message: "File size should not be exceed than 1MB.",
  //       },
  //     }));
  //   }
  // };
  const handleFile = async (file) => {
    if (file) {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]; // PDF and Word MIME types

      if (!allowedTypes.includes(file.type)) {
        setErrors((errors) => ({
          ...errors,
          resume: {
            message: "Only PDF and Word files are allowed.",
          },
        }));
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setErrors((errors) => ({
          ...errors,
          resume: {
            message: "File size should not exceed 1MB.",
          },
        }));
        return;
      }

      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "",
        },
      }));
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
      }));
      setResumeFile(file);
    } else {
      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "Please select a file.",
        },
      }));
    }
  };

  const handleDropdownChange = async (e, name) => {
    const { value } = typeof e?.target == "undefined" ? e : e?.target;
    // Prepare the updated form data
    const updatedFormData = {
      ...formData,
      [name]: typeof e?.target == "undefined" ? e : value,
    };

    // If the changed field is "ReferralID", reset the "referralType" field
    if (name === "ReferralID") {
      updatedFormData.referralType = null;
    }

    setFormData(updatedFormData);

    // Trigger validation for the specific field
    const error = validate(name, value, updatedFormData);

    // If validation returns no error, hide the error message
    if (!error.status) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null, // Clear the error for this field
      }));
    }


    if (name === "ReferralID") {
      let inputStateMap = [2035, 2034, 2037, 6768, 2036];
      let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];

      let selected = inputStateMap.indexOf(value);
      if (selected >= 0) {
        const response = await GetServiceCaller(
          API_URL + "get-referred-by-value/" + value
        );
        const referrealsOptions = response?.data?.referrals?.map((option) => ({
          value: option.VALUE,
          label: option.TEXT,
        }));
        setReferrals([{ label: "Select...", value: "" }, ...referrealsOptions]);
        setReferralInput({
          show: true,
          label: label[selected],
          placeholder: label[selected],
        });
      } else {
        setReferralInput({ show: false, label: "", placeholder: "" });
      }
    }
  };

  const [statusOption, setStatusOption] = useState(47);
  const [statusData, setStatusData] = useState([]);

  useEffect(() => {
    fetchDetails();
  }, []);
  const fetchDetails = async () => {
    let response = await GetServiceCaller(API_URL + "newapplication");
    response = response?.data;
    //setting json data for work domain
    setJsonData(response?.data?.projectworkdomain);
    // setting lead candidate status
    setStatusData(response?.data?.LeadCandidateStatus);
    //setting job title and selected job title
    setJobTitleOption([
      { value: "", label: "Select..." },
      ...response?.data?.job_titles,
    ]);
    let selected_job_title = response?.data?.job_titles?.find(
      (o) => o.value == job_master_id
    );

    // If job_master_id is 0 or not matched, fetch title from the job description record
    if (!selected_job_title && id) {
      try {
        const jdResponse = await GetServiceCaller(`${API_URL}JobDescriptions?jobDescriptionid=${id}`);
        const jdList = jdResponse?.data?.data?.data || [];
        const jdRecord = jdList.find((j) => String(j.ID) === String(id));
        if (jdRecord) {
          selected_job_title = {
            value: jdRecord.JobMasterID || id,
            label: jdRecord.Title || jdRecord.TitleWithJobCode || jdRecord.JobTitle || "",
          };
        }
      } catch (e) {
        console.error("Error fetching job description for title:", e);
      }
    }

    setFormData((prevState) => ({
      ...prevState,
      job_title: selected_job_title,
    }));
    setPageLoading(false);
    // setting hr dropdown
    let hrOpt = response?.data?.hr?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    let user = JSON.parse(localStorage.getItem("user"));
    let defaultContactID = user?.ID;
    let selectedHR = hrOpt?.find((o) => o.value == defaultContactID);
    setHrOption([{ value: "", label: "Select..." }, ...hrOpt]);
    setFormData((prevState) => ({
      ...prevState,
      hr: selectedHR,
      // 'LeadCandidateStatus_189':response.data.LeadCandidateStatus.value
    }));

    // setting gender
    let genderOpt = response?.data?.gender?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setGenderOption([{ value: "", label: "Select..." }, ...genderOpt]);
    // setting sourcre option
    let sourceOpt = response?.data?.source?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setSourceOption([{ value: "", label: "Select..." }, ...sourceOpt]);
    //setting skills and subkills
    const skilsOption = response?.data?.skills?.map((skill) => ({
      value: skill.ID,
      label: skill.Name,
    }));
    setskillsetOptions(skilsOption);
  };
  const fetchStatusOptions = async () => {
    try {
      const response = await GetServiceCaller(API_URL + "newapplication");
      setStatusData(response?.data?.LeadCandidateStatus);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching status options:", error);
    }
  };

  const handleOptionChange = (event) => {
    setStatusOption(parseInt(event.target.value));
  };

  // const handleToggle = (key) => {
  //   setActiveKey(activeKey === key ? null : key);
  // };

  const customStyle = {
    // for control
    control: (provided, state) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    //for common cross icon
    multiValueRemove: (base, state) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    //for  dropdown icon
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0px",
    }),
    //for dropdown conatiner
    indicatorsContainer: (provided, state) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };


const [isDuplicate, setIsDuplicate] = useState({ 
  EmailID: false, 
  MobileNo: false 
});
const [checkDuplicateErrmsg, setCheckDuplicateErrmsg] = useState({ 
  EmailID: "", 
  MobileNo: "" 
});

const handleSubmit = async (e) => {
  e.preventDefault();

  // Check duplicate status before submitting
  // Check duplicate status before submitting
  if (isDuplicate.EmailID || isDuplicate.MobileNo) {
    if (isDuplicate.EmailID) {
      // toast.error(checkDuplicateErrmsg.EmailID || "Email already exists");
         setErrors(prev => ({
        ...prev,
        EmailID: { status: true, message: checkDuplicateErrmsg.EmailID }
      }));
    }
    if (isDuplicate.MobileNo) {
      setErrors(prev => ({
        ...prev,
        MobileNo: { status: true, message: checkDuplicateErrmsg.MobileNo }
      }));
    }
    return;
  }


  // Validate mandatory fields
  const mandatory_fields = [
    "job_title",
    "AppliedDate",
    "hr",
    "FirstName",
    "LastName",
    "Gender",
    "EmailID",
    "DateOfBirth",
    "MobileNo",
    "CurrentPosition",
    "ReferralID",
    "CurrentCompanyName",
    "SkillSet",
    "CurrentCTC",
    "ExpectedCTC",
    "NoticePeriod",
  ];

  let isFormInvalid = false;
  let displayedErrors = new Set();

  for (let field of mandatory_fields) {
    const error = await validate([field], formData[field], formData);
    if (error.status) {
      isFormInvalid = true;
      if (!displayedErrors.has(field)) {
        // CTC can fail on format as well, so show what actually went wrong
        const isCtcField = field === "CurrentCTC" || field === "ExpectedCTC";
        toast.error(
          isCtcField && error.message
            ? error.message
            : `${fieldToLabel(field)} is required`
        );
        displayedErrors.add(field);
      }
    }
    setErrors(prev => ({ ...prev, [field]: error }));
  }

  // Validate resume
  if (resumeFile.length === 0) {
    isFormInvalid = true;
    setErrors(prev => ({
      ...prev,
      resume: { status: true, message: "Candidate Resume is required" }
    }));
    if (!displayedErrors.has("resume")) {
      toast.error("Candidate Resume is required");
      displayedErrors.add("resume");
    }
  }

  // Validate referral
  if (!formData?.ReferralID?.value) {
    isFormInvalid = true;
    setErrors(prev => ({
      ...prev,
      ReferralID: { status: true, message: "Source is required" }
    }));
    if (!displayedErrors.has("ReferralID")) {
      toast.error("Source is required");
      displayedErrors.add("ReferralID");
    }
  }

  if (!isFormInvalid) {
    setSubmit(true);
    try {
      const updatedFormData = {
        ...formData,
        job_description_id: id,
        ProjectOtherDesc: NoOfProjectContent,
        ProjectDetails: roleOfProjectContent,
        LeadCandidateStatus_189: statusOption,
        job_title: formData.job_title?.value,
        hr: formData.hr?.value,
        referralType: formData?.referralType?.value,
        resumeFile: resumeFile,
      };

      const response = await PostFormServiceCaller(
        `${API_URL}newapplication`,
        updatedFormData,
        "post"
      );

      if (response?.data?.status === "success") {
        toast.success(response.data.message);
        navigate(statusOption === 47 ? "/candidate-in-process" : "/hrinterviews");
      } else {
        toast.error(response.data.message || "Submission failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setSubmit(false);
    }
  }
};

const handleEmailMobileVerify = async (e) => {
  const { name, value } = e.target;

  // Clear previous errors and reset duplicate status for this field
  setErrors(prev => ({ ...prev, [name]: { status: false, message: "" } }));
  setIsDuplicate(prev => ({ ...prev, [name]: false }));
  setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: "" }));

  // Update form data
  setFormData(prev => ({ ...prev, [name]: value }));

  // Validate email format
  if (name === "EmailID") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setErrors(prev => ({
        ...prev,
        EmailID: { status: true, message: "Invalid email format" }
      }));
      return;
    }
  }

  // Validate mobile format
  if (name === "MobileNo") {
    const mobileRegex = /^(?:\d{10}|\d{12})$/;
    if (!mobileRegex.test(value)) {
      setErrors(prev => ({
        ...prev,
        MobileNo: { status: true, message: "Invalid mobile number (10 or 12 digits required)" }
      }));
      return;
    }
  }

  // Get current values
  const currentEmail = name === "EmailID" ? value : formData.EmailID;
  const currentMobile = name === "MobileNo" ? value : formData.MobileNo;

  // Skip API if both fields are empty
  if (!currentEmail && !currentMobile) return;

  try {
    const response = await PostServiceCaller(
      `${API_URL}check-duplicates`,
      {
        EmailID: name === "EmailID" ? value : null,
        MobileNo: name === "MobileNo" ? value : null
      },
      "post"
    );

    const res = response?.data;

    if (res?.status === "unique") {
      setIsDuplicate(prev => ({ ...prev, [name]: false }));
      setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: "" }));
      // Only show success if both fields are valid
      if ((name === "EmailID" && !isDuplicate.MobileNo) || 
          (name === "MobileNo" && !isDuplicate.EmailID)) {
        // toast.success(res.message || "Validation successful");
      }
    } else if (res?.status === "failed") {
      setIsDuplicate(prev => ({ ...prev, [name]: true }));
      const errorMsg = res.message || 
        (name === "EmailID" ? "Email already exists" : "Mobile number already exists");
      setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: errorMsg }));
       setErrors(prev => ({
        ...prev,
        [name]: { status: true, message: errorMsg }
      }));
      // toast.error(errorMsg);
    }
  } catch (error) {
    toast.error("Server error while checking duplicates");
  }
};

// Helper function to convert field names to display-friendly format
const fieldToLabel = (field) => {
  const map = {
    "job_title": "Job Title",
    "AppliedDate": "Applied Date",
    "hr": "HR",
    "FirstName": "First Name",
    "LastName": "Last Name",
    "EmailID": "Email",
    "DateOfBirth": "Date of Birth",
    "MobileNo": "Mobile Number",
    "CurrentPosition": "Current Position",
    "CurrentCompanyName": "Current Company",
    "SkillSet": "Skill Set",
    "ReferralID": "Referral ID",
    "CurrentCTC": "Current CTC",
    "ExpectedCTC": "Expected CTC"
  };
  return map[field] || field;
};

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <form
            id="formOne"
            className="rounded mt-2 bg-white"
            onSubmit={handleSubmit}
          >
            <div>
              {/* tab code start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="job-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#job"
                    type="button"
                    role="tab"
                    aria-controls="job"
                    aria-selected="true"
                  >
                    Job Details
                    <span className="text-Primary">
                      {formData.job_title?.label.trim() &&
                        `: ${formData.job_title.label}`}
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="personal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-controls="personal"
                    aria-selected="false"
                  >
                    Personal Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="project-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#project"
                    type="button"
                    role="tab"
                    aria-controls="project"
                    aria-selected="false"
                  >
                    Last Employment & Project Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="rating-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#rating"
                    type="button"
                    role="tab"
                    aria-controls="rating"
                    aria-selected="false"
                  >
                    Rating
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="other-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#other"
                    type="button"
                    role="tab"
                    aria-controls="other"
                    aria-selected="false"
                  >
                    Other Details
                  </button>
                </li>
              </ul>

              {/* tab main section code start */}
              <div className="tab-content" id="myTabContent">
                {/* Job Details Section */}
                <div
                  className="tab-pane fade show active"
                  id="job"
                  role="tabpanel"
                  aria-labelledby="job-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Job Title
                          <span className="required">*</span>
                        </label>
                        <Select
                          onChange={(e) => handleDropdownChange(e, "job_title")}
                          selected={formData?.job_title?.value}
                          value={formData?.job_title}
                          name="job_title"
                          options={jobTitleOption}
                        />
                        {errors?.job_title?.status && (
                          <span class="error">
                            {errors?.job_title?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          Applied Date
                          <span className="required">*</span>
                        </label>
                        <ReactDatePicker
                          changeYear
                          showPopperArrow
                          showIcon
                          icon="fa fa-calendar"
                          className="form-control"
                          placeholderText="To Date"
                          format="DD-MMM-YYYY" // Format to display in the input field
                          name="AppliedDate"
                          id="AppliedDate"
                          onChange={(date) =>
                            handleDateChange(date, "AppliedDate")
                          }
                          value={formData.AppliedDate}
                        />
                        {errors?.AppliedDate?.status && (
                          <span class="error">
                            {errors?.AppliedDate?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label className="form-label">
                          HR Name <span className="required">*</span>
                        </label>
                        <Select
                          onChange={(e) => handleDropdownChange(e, "hr")}
                          value={formData.hr}
                          name="hr"
                          options={hrOption}
                        />
                        {errors?.hr?.status && (
                          <span class="error">{errors?.hr?.message}</span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3 d-flex align-items-end">
                        <button
                          type="button"
                          className="custom-btn"
                          onClick={() => setShowModal(true)}
                        >
                          Upload Resume(Resume Parser)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Personal Details Section */}
                <div
                  className="tab-pane fade show"
                  id="personal"
                  role="tabpanel"
                  aria-labelledby="personal-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-lg-9 mt-2">
                        <div className="row">
                          <div className="col-md-4">
                            <label className="form-label">
                              First Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="First Name"
                              className="form-control"
                              id="FirstName"
                              name="FirstName"
                              onChange={handleChange}
                              value={formData.FirstName}
                            />
                            {errors?.FirstName?.status && (
                              <span class="error">
                                {errors?.FirstName?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Last Name
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Last Name"
                              className="form-control"
                              id="LastName"
                              name="LastName"
                              onChange={handleChange}
                              value={formData.LastName}
                            />
                            {errors?.LastName?.status && (
                              <span class="error">
                                {errors?.LastName?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Gender<span className="required">*</span>
                            </label>
                            <Select
                              options={genderOption}
                              name="Gender"
                              value={formData.Gender}
                              onChange={(e) =>
                                handleDropdownChange(e, "Gender")
                              }
                            />

                            {errors?.Gender?.status && (
                              <span class="error">
                                {errors?.Gender?.message}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-label">
                                DOB<span className="required">*</span>
                              </label>
                              <CustomDatePicker
                                handleChange={handleChange}
                                value={formData.DateOfBirth}
                                name="DateOfBirth"
                                id="DateOfBirth"
                                className="form-control"
                                placeholderText="Date Of Birth"
                              ></CustomDatePicker>
                              {errors?.DateOfBirth?.status && (
                                <span class="error">
                                  {errors?.DateOfBirth?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Contact No
                              <span className="required">*</span>
                            </label>
                            {/* <input
                                minLength={0}
                                maxLength={10}
                                type="text"
                                className="form-control"
                                placeholder="Mobile No"
                                id="MobileNo"
                                name="MobileNo"
                                onChange={handleChange}
                                value={formData.MobileNo}
                              /> */}
                            <input
                              // defaultCountry="in"
                              // className="input.react-international-phone-input"
                              className="form-control"
                              name="MobileNo"
                              onBlur={handleEmailMobileVerify}

                              value={formData.MobileNo || ""}
                              // onChange={(phone) => {
                              //   const isValid = phone && phone.length > 4;
                              //   setFormData({
                              //     ...formData,
                              //     MobileNo: isValid ? phone : "",
                              //   });
                              //   setErrors((errors) => ({
                              //     ...errors,
                              //     MobileNo: isValid
                              //       ? ""
                              //       : "Invalid phone number",
                              //   }));
                              // }}
                              onChange={handleChange}
                              placeholder="Contact No."
                            />
                            {errors?.MobileNo?.status && (
                              <span class="error">
                                {errors?.MobileNo?.message}
                              </span>
                            )}
                            {/* {mobileNoError && (
                              <div style={{ color: "red" }}>
                                {mobileNoError}
                              </div>
                            )} */}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Alternate Contact No
                            </label>

                            {/* <input
                              maxLength={10}
                              minLength={10}
                              type="text"
                              placeholder="Mobile No"
                              className="form-control"
                              id="MobileNo1"
                              name="MobileNo1"
                              onChange={handleChange}
                              value={formData.MobileNo1}
                            /> */}
                            <input
                              className="form-control"
                              // defaultCountry="in"
                              // className="input.react-international-phone-input"
                              name="MobileNo1"
                              value={formData.MobileNo1 || ""}
                              // onChange={(phone) =>
                              //   setFormData({
                              //     ...formData,
                              //     MobileNo1:
                              //       phone && phone.length > 4 ? phone : "",
                              //   })
                              // }
                              onChange={handleChange}
                              placeholder="Contact No."
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Email ID
                              <span className="required">*</span>
                            </label>
                            <input
                              type="email"
                              placeholder="Email Id"
                              className="form-control"
                              id="EmailID"
                              name="EmailID"
                              onChange={handleChange}
                              onBlur={handleEmailMobileVerify}
                              value={formData.EmailID}
                            />
                            {errors?.EmailID?.status && (
                              <span class="error">
                                {errors?.EmailID?.message}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-4">
                            <RatingComponentWithoutNA
                              label="Introduction"
                              name="IntroduceYourself"
                              value={formData.IntroduceYourself}
                              onChange={(value) =>
                                handleRatingChange("IntroduceYourself", value)
                              }
                            />
                          </div>

                          <div className="col-md-4">
                            <RatingComponentWithoutNA
                              label="Oral Skills"
                              name="OralSkills"
                              value={formData.OralSkills}
                              onChange={(value) =>
                                handleRatingChange("OralSkills", value)
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <RatingComponentWithoutNA
                              label="Accent"
                              name="Accent"
                              value={formData.Accent}
                              onChange={(value) =>
                                handleRatingChange("Accent", value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="col-md-12 mt-2">
                          <label className="form-label">
                            Skill Sets<span className="required">*</span>
                          </label>
                          <Select
                            menuShouldScrollIntoView={true}
                            isMulti
                            name="SkillSet"
                            options={skillsetOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={formData.SkillSet}
                            onChange={handleSkillChange}
                            styles={customStyle}
                          />
                          {errors?.SkillSet?.status && (
                            <span class="error">
                              {errors?.SkillSet?.message}
                            </span>
                          )}
                        </div>
                        <div className="col-md-12 mt-3">
                          <label className="form-label">SubSkill Sets</label>
                          <Select
                            isMulti
                            name="SubSkillSet"
                            options={subSkillOptions}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={formData.SubSkillSet}
                            onChange={handleSubSkillChange}
                            styles={customStyle}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Last Employee & Project Details section */}
                <div
                  className="tab-pane fade show"
                  id="project"
                  role="tabpanel"
                  aria-labelledby="project-tab"
                >
                  <div className="container-fluid mt-2">
                    <div class="row">
                      <div className="col-md-6 col-lg-2">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          placeholder="Company Name"
                          className="form-control"
                          id="CurrentCompanyName"
                          name="CurrentCompanyName"
                          onChange={handleChange}
                          value={formData.CurrentCompanyName}
                        />
                        {errors?.CurrentCompanyName?.status && (
                          <span class="error">
                            {errors.CurrentCompanyName?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <label class="form-label">
                          Designation
                          <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Designation"
                          class="form-control"
                          id="CurrentPosition"
                          name="CurrentPosition"
                          onChange={handleChange}
                          value={formData.CurrentPosition}
                        />
                        {errors?.CurrentPosition?.status && (
                          <span class="error">
                            {errors?.CurrentPosition?.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-2">
                        <label for="Qualifications" class="form-label">
                          Qualification
                        </label>
                        <input
                          type="text"
                          placeholder="Qualifications"
                          class="form-control"
                          id="Qualifications"
                          name="Qualifications"
                          onChange={handleChange}
                          value={formData.Qualifications}
                        />
                      </div>
                      <div className="col-md-6 col-lg-2">
                        <Form.Label>Notice Period(in Days)<span className="text-danger">*</span></Form.Label>
                        <Select
                          class="form-select"
                          aria-label="Default select example"
                          options={notice_period}
                          onChange={(selected) => {
                            handleDropdownChange(selected, "NoticePeriod");
                          }}
                          name="NoticePeriod"
                          value={formData.NoticePeriod}
                        ></Select>
                        {errors?.NoticePeriod?.status && (
                          <span className="error">{errors?.NoticePeriod?.message}</span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <Form.Label>Notice Period Remarks</Form.Label>
                        <Form.Control
                          type="text"
                          name="NoticePeriodRemarks"
                          value={formData.NoticePeriodRemarks}
                          onChange={handleChange}
                          placeholder="Enter remarks..."
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6 col-lg-3 mt-2">
                        <div className="d-flex flex-column">
                          <label className="form-label">Experience</label>
                          <div className="row">
                            <div className="col-md-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Exp. in yrs
                                  </Tooltip>
                                }
                              >
                                <input
                                  JobType="text"
                                  className="form-control text-end"
                                  id="CurrentExperienceInYears"
                                  name="CurrentExperienceInYears"
                                  placeholder="Experience"
                                  value={formData.CurrentExperienceInYears}
                                  onChange={handleChange}
                                />
                              </OverlayTrigger>
                            </div>
                            <div className="col-md-6">
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-bottom">
                                    Rel. Exp. In Yrs
                                  </Tooltip>
                                }
                              >
                                <input
                                  JobType="text"
                                  className="form-control text-end"
                                  id="CurrentRelevantExperienceInYears"
                                  name="CurrentRelevantExperienceInYears"
                                  placeholder="Rel Experience"
                                  value={
                                    formData.CurrentRelevantExperienceInYears
                                  }
                                  onChange={handleChange}
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                        </div>
                          <div className="d-flex flex-column mt-4">
                            <label htmlFor="CTC" className="form-label">
                              CTC<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-md-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="CurrentCTC"
                                    name="CurrentCTC"
                                    placeholder="e.g. 820000"
                                    value={formData.CurrentCTC}
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                  />
                                </OverlayTrigger>
                                {errors?.CurrentCTC?.status && (
                                  <span className="error">{errors?.CurrentCTC?.message}</span>
                                )}
                              </div>
                              <div className="col-md-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Expected CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="ExpectedCTC"
                                    name="ExpectedCTC"
                                    placeholder="e.g. 900000"
                                    value={formData.ExpectedCTC}
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                  />
                                </OverlayTrigger>
                                {errors?.ExpectedCTC?.status && (
                                  <span className="error">{errors?.ExpectedCTC?.message}</span>
                                )}
                              </div></div>
                          </div>
                        </div>
                      <div className="col-md-6 col-lg-9">
                        <div className="col-md-12">
                          <label className="form-label">
                            1. Work Details
                            {/* <span className="required">*</span> */}
                          </label>
                          <Editor
                            onEditorChange={handleEditorChangeNoOfProject}
                          />
                          {errors?.NoOfProjectContent?.status && (
                            <span class="error">
                              {errors?.NoOfProjectContent?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col-md-12 mt-2">
                        <Form.Label>
                          2. Which domains have you worked in?
                        </Form.Label>
                        <div class="col-md-12">
                          <div className="row">
                            {jsonData &&
                              jsonData.map((item) => (
                                <div
                                  key={item.value}
                                  className="col-md-6 col-lg-3"
                                >
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={item.value}
                                      value={item.value}
                                      checked={selectedOptions.includes(
                                        item.value
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(item.value)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={item.value}
                                    >
                                      {item.text}
                                    </label>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rating Section start */}
                <div
                  className="tab-pane fade show"
                  id="rating"
                  role="tabpanel"
                  aria-labelledby="rating-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div class="mt-2">
                          <RatingComponent
                            label="Dashboard Development"
                            name="AreaDashboard"
                            value={formData.AreaDashboard}
                            onChange={(value) =>
                              handleRatingChange("AreaDashboard", value)
                            }
                          />
                        </div>
                        <div class="mt-4">
                          <RatingComponent
                            label="Architecture"
                            name="AreaArchitecture"
                            value={formData.AreaArchitecture}
                            onChange={(value) =>
                              handleRatingChange("AreaArchitecture", value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div class="mt-2">
                          <RatingComponent
                            label="SDK"
                            name="AreaSDK"
                            value={formData.AreaSDK}
                            onChange={(value) =>
                              handleRatingChange("AreaSDK", value)
                            }
                          />
                        </div>
                        <div class="mt-4">
                          <RatingComponent
                            label="Report Development"
                            name="AreaReport"
                            value={formData.AreaReport}
                            onChange={(value) =>
                              handleRatingChange("AreaReport", value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div class="mt-2">
                          <RatingComponent
                            label="Administration"
                            name="AreaAdministration"
                            value={formData.AreaAdministration}
                            onChange={(value) =>
                              handleRatingChange("AreaAdministration", value)
                            }
                          />
                        </div>
                        <div class="mt-4">
                          <RatingComponent
                            label="Other Skills"
                            name="AreaOtherSkill"
                            value={formData.AreaOtherSkill}
                            onChange={(value) =>
                              handleRatingChange("AreaOtherSkill", value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other Detail */}
                <div
                  className="tab-pane fade show"
                  id="other"
                  role="tabpanel"
                  aria-labelledby="other-tab"
                >
                  <div className="container-fluid mt-2">
                    <div className="row">
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group d-flex flex-column">
                          <label
                            htmlFor="WillingToTravel"
                            className="form-label"
                          >
                            Willing To Travel
                          </label>
                          <div className="d-flex gap-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="Yes"
                                value="Yes"
                                onChange={handleRadioChange}
                              />
                              <label className="form-check-label" htmlFor="Yes">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="no"
                                value="No"
                                onChange={handleRadioChange}
                              />
                              <label className="form-check-label" htmlFor="no">
                                No
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="occasionally"
                                value="Occasionally"
                                onChange={handleRadioChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="occasionally"
                              >
                                Occasionally
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="CurrentLocation"
                            className="form-label"
                          >
                            Current Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="CurrentLocation"
                            name="CurrentLocation"
                            onChange={handleChange}
                            value={formData.CurrentLocation}
                            placeholder="Current Location"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="PreferredLocation"
                            className="form-label"
                          >
                            Preferred Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="PreferredLocation"
                            name="PreferredLocation"
                            onChange={handleChange}
                            value={formData.PreferredLocation}
                            placeholder="Preferred Location"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group">
                          <label
                            htmlFor="ReasonForChange"
                            className="form-label"
                          >
                            Reason For Change
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ReasonForChange"
                            name="ReasonForChange"
                            onChange={handleChange}
                            value={formData.ReasonForChange}
                            placeholder="Reason"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-3 mt-2">
                        <div className="form-group">
                          <label htmlFor="ReferralNote" className="form-label">
                            Notes
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ReferralNote"
                            name="ReferralNote"
                            onChange={handleChange}
                            value={formData.ReferralNote}
                            placeholder="Note"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <Form.Group className="col-form-label">
                          <Form.Label>
                            Source<span className="required">*</span>
                          </Form.Label>
                          {/* <CommanDropdown name='ReferralID' url={API_URL + 'fetch-referral-type'} value={formData.ReferralID} handleChange={(value) => handleDropdownChange('ReferralID', value)} /> */}
                          <Select
                            options={sourceoption}
                            name="ReferralID"
                            url={API_URL + "fetch-referral-type"}
                            onChange={(e) =>
                              handleDropdownChange(e, "ReferralID")
                            }
                          // showOthersInput={handleAdditionalInputChange}
                          />
                          {errors?.ReferralID?.status && (
                            <span class="error">
                              {errors?.ReferralID?.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        {refferralDetails.show && (
                          <Form.Group className="col-form-label">
                            <label className="form-label">
                              {refferralDetails.label}
                            </label>
                            <Select
                              name="referralType"
                              options={referrals}
                              // className="basic-multi-select"
                              // classNamePrefix="select"
                              onChange={(e) => {
                                handleDropdownChange(e, "referralType");
                              }}
                              placeholder={refferralDetails.placeholder}
                              value={formData.referralType}
                            />
                          </Form.Group>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3 mt-lg-5">

                        <div>
                          <FileUploader isRequired={true} handleFile={handleFile} />
                        </div>
                        <div style={{ width: "100%" }}>
                          {FileName ? (
                            <a
                              href={resumeFile && resumeFile instanceof File ? URL.createObjectURL(resumeFile) : "#"}
                              target="_blank"
                              rel="noreferrer"
                              className="mb-0"
                              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                            >
                              {FileName}
                            </a>
                          ) : null}
                        </div>
                        <span class="error">{errors?.resume?.message}</span>
                      </div>
                    </div>

                    <div className="col-sm-12 d-flex justify-content-center">
                      <label className="form-label me-4">Status</label>
                      {statusData.map((option) => (
                        <div
                          key={option.value}
                          className="form-check form-check-inline"
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            id={option.value}
                            name="LeadCandidateStatus_189"
                            value={option.value}
                            checked={statusOption === option.value}
                            onChange={handleOptionChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={option.value}
                          >
                            {option.text}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid d-flex justify-content-end mt-2">
                <div>
                  <button
                    className="cancel-btn me-2"
                    onClick={() => navigate('/hrinterviews')}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={submitted ? true : false}
                    onClick={handleSubmit}
                    type=""
                    className="custom-btn"
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-sm"
            role="document"
            style={{
              width: "300px",
              margin: 0,
            }}
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  Upload Resume
                </p>

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
              <div
                className="modal d-flex align-items-center justify-content-center"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1050,
                  display: "flex !important",
                }}
              >
                {/* Modal Dialog */}
                <div
                  className="modal-dialog modal-dialog-centered"
                  style={{ maxWidth: "450px" }}
                >
                  <div
                    className="modal-content shadow-lg"
                    style={{
                      borderRadius: "16px",
                      border: "none",
                      overflow: "hidden",
                    }}
                  >
                    {/* Header */}
                    <div className="modal-header border-0 pb-2">
                      <h5 className="modal-title fw-semibold text-dark">
                        Upload Resume
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleCancel}
                        style={{
                          background: "none",
                          border: "none",
                          fontSize: "1.2rem",
                          opacity: 0.6,
                        }}
                      >
                        <X size={20} />
                      </button>
                    </div>

                    {/* Body */}
                    <div className="modal-body px-4 pb-4">
                      {/* Upload Area */}
                      <div className="mb-4">
                        {!uploadedFile ? (
                          <div
                            className={`border border-2 border-dashed rounded p-5 text-center position-relative ${
                              isDragging
                                ? "border-primary bg-light"
                                : "border-secondary"
                            }`}
                            style={{
                              borderRadius: "12px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                              backgroundColor: isDragging
                                ? "#f8f9fa"
                                : "#fafafa",
                            }}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onMouseEnter={(e) => {
                              if (!isDragging) {
                                e.target.style.backgroundColor = "#f8f9fa";
                                e.target.style.borderColor = "#6c757d";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isDragging) {
                                e.target.style.backgroundColor = "#fafafa";
                                e.target.style.borderColor = "#dee2e6";
                              }
                            }}
                          >
                            {/* Upload Icon */}
                            <div className="mb-3">
                              <div
                                className="d-inline-flex align-items-center justify-content-center"
                                style={{
                                  width: "64px",
                                  height: "64px",
                                  backgroundColor: "#e9ecef",
                                  borderRadius: "16px",
                                }}
                              >
                                <Upload
                                  size={32}
                                  style={{ color: "#6f42c1" }}
                                />
                              </div>
                            </div>

                            {/* Upload Text */}
                            <div>
                              <p className="mb-2 fw-medium text-dark">
                                Drag and drop or{" "}
                                <button
                                  type="button"
                                  className="btn p-0 text-primary fw-semibold text-decoration-underline"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "inherit",
                                  }}
                                  onClick={() => fileInputRef.current?.click()}
                                >
                                  click to upload
                                </button>
                              </p>
                              <p className="text-muted small mb-0">
                                Maximum file size 5 MB
                              </p>
                              <p className="small mb-0 text-warning">
                                Please upload a PDF, DOCX, or DOC file.
                              </p>
                            </div>

                            {/* Hidden File Input */}
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept=".pdf,.doc,.docx"
                              onChange={handleFileSelect}
                              style={{ display: "none" }}
                            />
                          </div>
                        ) : (
                          /* Uploaded File Display */
                          <div
                            className="border rounded p-3"
                            style={{
                              borderColor: "#198754 !important",
                              backgroundColor: "#d1e7dd",
                              borderRadius: "12px",
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <div
                                  className="d-flex align-items-center justify-content-center me-3"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    backgroundColor: "#198754",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <FileText size={20} color="white" />
                                </div>
                                <div>
                                  <p
                                    className="mb-1 fw-medium text-dark"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {uploadedFile.name.length > 30
                                      ? `${uploadedFile.name.substring(
                                          0,
                                          30
                                        )}...`
                                      : uploadedFile.name}
                                  </p>
                                  <p className="text-muted small mb-0">
                                    {(uploadedFile.size / 1024 / 1024).toFixed(
                                      2
                                    )}{" "}
                                    MB
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <div
                                  className="d-flex align-items-center justify-content-center me-2"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    backgroundColor: "#198754",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <Check size={14} color="white" />
                                </div>
                                <button
                                  type="button"
                                  className="btn p-1"
                                  onClick={removeFile}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#dc3545",
                                    borderRadius: "50%",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = "#f8d7da";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                >
                                  <X size={16} />
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Action Buttons */}
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="custom-btn"
                          onClick={handleResumeSubmit}
                        >
                          {isUploading ? (
                            <>
                              <FaSpinner class="sm-spinner" />
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </>
    );
  }
};

export default NewApplication;
